import React, { useEffect, useRef, useState } from 'react';
import GameView from "@/view/game/GameView";
export const Main = () => {


    return (
        <>
            <div id={'Main'} className={'body'}>
                <GameView/>
            </div>
        </>
    );
};

export default Main;
